import { FC } from 'react';
import {
  ErrorMessageModal,
  LoadingModal
} from '../../form_components';
import { useServices, useSubject } from '../../hooks';
import { DiagnoseDesignDialog } from '../../widgets/dialogs';

/** Display global level modals (primarily ones displayed by services. */
export const GlobalModals: FC = () => {
  const { globalModalsService } = useServices();
  const activeDialog = useSubject(
    globalModalsService.activeDialogSubject,
    globalModalsService.activeDialog
  );

  return (
    <>
      {activeDialog}
      <DiagnoseDesignDialog />
      <LoadingModal />
      <ErrorMessageModal />
    </>
  );
};
